import React, { useEffect, useState } from "react";
import { Button } from "flowbite-react";
import axios from "axios";
import { ScheduledEvent } from "../../Models/ScheduleEvent";
import ScheduleEventsApi from "../../Api/ScheduleEventsApi";
import RequestDemoModal from "./RequestDemoModal";

export default function FarmShowSchedule() {
  const [events, setEvents] = useState<ScheduledEvent[]>([]);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    try {
      return ScheduleEventsApi.getEvents()
        .then((res) => {
          setEvents(res.data);
        })
        .catch((err) => {});
    } catch (error) {
      console.error(error);
    }
  };

  const formatDateRange = (start?: string, end?: string) => {
    if (!start) return "";
    const options: Intl.DateTimeFormatOptions = {
      month: "long",
      day: "numeric",
      year: "numeric",
    };
    const startDate = new Date(start).toLocaleDateString("en-US", options);
    if (end) {
      const endDate = new Date(end).toLocaleDateString("en-US", options);
      return `${startDate} - ${endDate}`;
    }
    return startDate;
  };

  // Split events evenly into two columns
  const midpoint = Math.ceil(events.length / 2);
  const leftEvents = events.slice(0, midpoint);
  const rightEvents = events.slice(midpoint);

  return (
    <>
      <div className="bg-white py-8 px-4">
        <h2 className="text-2xl font-bold mb-6 text-center">
          FARM SHOW & DEMO SCHEDULE
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 max-w-screen-xl mx-auto">
          {[1, 2, 3, 4, 5].map((i) => (
            <img
              key={i}
              src={`https://pricebrosstorage.blob.core.windows.net/data/sitepages/Farm%20Show%20${i}.jpg`}
              alt={`Equipment ${i}`}
              className="w-full h-[200px] object-cover rounded shadow-md"
            />
          ))}
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 py-10">
        {/* Event Listings */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-center md:text-left mb-10">
          <div className="space-y-4">
            {leftEvents.map((event) => (
              <div key={event.id}>
                <div className="font-bold">{event.title}</div>
                <div>
                  {formatDateRange(
                    event.dateOfEventStart,
                    event.dateOfEventEnd
                  )}
                </div>
              </div>
            ))}
          </div>
          <div className="space-y-4">
            {rightEvents.map((event) => (
              <div key={event.id}>
                <div className="font-bold">{event.title}</div>
                <div>
                  {formatDateRange(
                    event.dateOfEventStart,
                    event.dateOfEventEnd
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Button */}
        <div className="text-center">
          <Button
            color="dark"
            className="uppercase px-8 py-2 tracking-wide text-white"
            onClick={() => setModalOpen(true)}
          >
            Request Demo
          </Button>
          <RequestDemoModal
            show={modalOpen}
            onClose={() => setModalOpen(false)}
          />
        </div>
      </div>
    </>
  );
}
